import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {LeaveType} from 'main/stores/leave_types';
import {types, endpoints} from 'main/tools';
import {successAlert} from 'shared/tools';
import {t} from 'shared/core';
import _ from 'lodash';

class LeaveTypeEditState {
  store = new DomainStore();
  history;
  match;

  errors = {};
  leaveType;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  async load() {
    const id = _.get(this.match.params, 'id');

    if (id) {
      await this.store._compose([
        endpoints.LEAVE_TYPE.with(id)
      ]);
    }

    this.leaveType = new LeaveType(
      this.store._getSingle(types.LEAVE_TYPE, { id })
    );
  }

  async saveLeaveType() {
    const {model, errors} = this.leaveType.isNew ? 
      await this.createLeaveType() : 
      await this.store.patch(this.leaveType);
    this.errors = errors;

    if (model) {
      successAlert(t('company_settings.leave_types.Leave type saved'));
      this.history.push('/leave_types');
    }
  }

  async createLeaveType() {
    return this.store.post(
      endpoints.LEAVE_TYPES,
      types.LEAVE_TYPE,
      this.leaveType
    );
  }

  goBack() {
    this.history.push('/leave_types');
  }
}

export default LeaveTypeEditState;
